import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'statement-text',
  templateUrl: './statement-text.component.html',
  styleUrls: ['./statement-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatementTextComponent { }
